module.exports = __webpack_public_path__ + "static/media/patient.393655a9.svg";